import React from 'react';
import { Box, Container, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { usePropertyData } from '../../../common/hooks/usePropertyId';

const SiteFooter = () => {
  const { queryData } = usePropertyData();
  const propertyName = queryData?.data?.name;

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'primary.main',
        color: 'white',
        py: 4,
        mt: 8,
      }}
    >
      <Container>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={2}
          justifyContent="center"
          alignItems="center"
          sx={{ mb: 2 }}
        >
          <Link
            component={RouterLink}
            to="/regulamin"
            color="inherit"
            underline="hover"
            variant="body2"
          >
            Regulamin użytkowania
          </Link>
          <Link
            component={RouterLink}
            to="/rodo"
            color="inherit"
            underline="hover"
            variant="body2"
          >
            Klauzula informacyjna RODO
          </Link>
        </Stack>
        <Typography variant="body1" align="center">
          © {new Date().getFullYear()}
          {propertyName ? ` ${propertyName}.` : ''} Wszelkie prawa zastrzeżone.
        </Typography>
      </Container>
    </Box>
  );
};

export default SiteFooter;
